
export default {
  props: {
    available: {
      type: [Boolean, String],
      default: false
    }
  },
  computed: {
    show() {
      return this.available !== true
    },
    types() {
      return {
        false: 'info',
        wip: 'success'
      }
    },
    texts() {
      return {
        false: 'comingSoon',
        wip: 'inProgress'
      }
    }
  }
}
